/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Esempio } from './esempio';


export interface Gruppo { 
    metodo_http?: string;
    operazione?: string;
    path_modello?: string;
    status_code?: number;
    contatore?: number;
    prima_volta?: string;
    ultima_volta?: string;
    esempi?: Array<Esempio>;
}

